import React, { useState, useEffect } from 'react';
import { Text, StyleSheet } from 'react-native';
import { colors, fontSizes } from '../styles/theme';

interface CountdownTimerProps {
  initialSeconds: number;
  onExpire: () => void;
  format?: 'mm:ss' | 'text';
  style?: any;
  expiredText?: string;
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  initialSeconds,
  onExpire,
  format = 'mm:ss',
  style,
  expiredText = 'Code expired',
}) => {
  const [timeLeft, setTimeLeft] = useState(initialSeconds);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsExpired(true);
      onExpire();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          setIsExpired(true);
          onExpire();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, onExpire]);

  const formatTime = (seconds: number): string => {
    if (format === 'mm:ss') {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    } else {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      
      if (minutes > 0) {
        return `${minutes} minute${minutes !== 1 ? 's' : ''} ${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}`;
      } else {
        return `${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}`;
      }
    }
  };

  if (isExpired) {
    return (
      <Text style={[styles.expiredText, style]}>
        {expiredText}
      </Text>
    );
  }

  return (
    <Text style={[styles.timerText, style]}>
      {formatTime(timeLeft)}
    </Text>
  );
};

const styles = StyleSheet.create({
  timerText: {
    fontSize: fontSizes.sm,
    color: colors.gray500,
    fontWeight: '500',
    textAlign: 'center',
  },
  expiredText: {
    fontSize: fontSizes.sm,
    color: colors.error,
    fontWeight: '600',
    textAlign: 'center',
  },
}); 